/**
 * Formats a timestamp for display in the DevTools panel.
 *
 * Anything the runtime cannot parse is shown verbatim rather than as
 * "Invalid Date": in a diagnostics panel the raw value is the useful part.
 *
 * @param time - ISO timestamp, or null when the event has not happened yet
 * @param options.fallback - Shown when there is no timestamp at all
 * @param options.withDate - Include the date; off by default, because within a
 *   single call only the time of day tells the reader anything.
 */
export const formatTimestamp = (
  time: string | null | undefined,
  { fallback, withDate = false }: { fallback: string; withDate?: boolean }
): string => {
  if (!time) {
    return fallback;
  }

  const parsed = new Date(time);

  if (Number.isNaN(parsed.getTime())) {
    return time;
  }

  return withDate ? parsed.toLocaleString() : parsed.toLocaleTimeString();
};
